/* eslint-disable node/no-unsupported-features/es-syntax */
import { RENT_ROUTE_NAMES } from "@/shared";
export const RENT_ROUTES = [
    {
        name: RENT_ROUTE_NAMES.LIST,
        path: "/rent",
        meta: {
            title: "words.rentals",
        },
        props: (route) => ({
            ...route.params,
            ...route.query,
        }),
        component: () => import("../ui/RentList.vue"),
    },
    {
        name: RENT_ROUTE_NAMES.ADD,
        path: "/rent/add",
        meta: {
            title: "words.add_rental",
        },
        component: () => import("../ui/RentEdit.vue"),
    },
    {
        name: RENT_ROUTE_NAMES.EDIT,
        path: "/rent/edit/:id",
        meta: {
            title: "words.edit_rental",
        },
        props: true,
        component: () => import("../ui/RentEdit.vue"),
    },
];
